// extracted by mini-css-extract-plugin
module.exports = {"episodes":"PodcastEpisodesSection_episodes__etzNd","episodes__title":"PodcastEpisodesSection_episodes__title__6WYvU"};